import { render, staticRenderFns } from "./RewardBtn.vue?vue&type=template&id=203bda7e&scoped=true&"
import script from "./RewardBtn.vue?vue&type=script&lang=js&"
export * from "./RewardBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203bda7e",
  null
  
)

export default component.exports